import axios from "axios";
import infrastructureApi from "./InfrastructureApi";

export async function acceptTermsAndConditions({ userId, version }) {
    const { data } = await axios.post(
        "/api/user/registration/terms/accept",
        {
            user_id: userId,
            version,
        },
        { withCredentials: true }
    );

    return data;
}

export async function activateAccount(
    user_id
) {
    const {
        data,
    } = await axios.post(
        "/api/user/registration/activate",
        {
            user_id,
        }
    );

    return data;
}
export async function sendVerificationCode(
    user_id
) {
    const { data } =
        await infrastructureApi.post(
            "/verification/send",
            {
                user_id,
            }
        );

    return data;
}

export async function verifyEmailCode(user_id, code) {
    const { data } = await axios.post("/api/user/registration/email/verifyEmail", { user_id, code });
    return data;
}
export async function getDataPrepStatus(
    user,
    farm_id
) {
    const { data } = await axios.get(
        "/api/user/registration/data-prep/status",
        {
            params: {
                user_id: user.user_id,
                farm_id,
            },
            withCredentials: true,
        }
    );

    return data;
}

export async function getCropTypes() {
    const { data } = await axios.get(
        "/api/user/registration/crops/types",
        { withCredentials: true }
    );

    return data.crop_types;
}

export async function getCropVarieties(cropType) {
    const { data } = await axios.get(
        `/api/user/registration/crops/varieties?type=${cropType}`,
        { withCredentials: true }
    );

    return data.crop_varieties;
}

export async function submitCropSuggestion(payload) {
    const { data } = await axios.post(
        "/api/user/registration/crops/suggest",
        payload,
        { withCredentials: true }
    );

    return data;
}

export async function submitUserRegistration(payload) {
    const { data } = await axios.post(
        "/api/user/registration/user",
        payload,
        { withCredentials: true }
    );

    return data;
}

export async function grabCropValues() {
    const { data } = await axios.get(
        "/api/user/registration/crops/values",
        { withCredentials: true }
    );

    return data;
}